import type { BrandingEntityType } from "database";
import type { BrandingCacheKey, BrandingLevel } from "./types";

export function resolveBrandingCacheKey(
  entityType: BrandingEntityType | "DEFAULT",
  entityId: string
): BrandingCacheKey {
  return `${entityType}:${entityId}`;
}

export function brandingLevelFromEntityType(
  entityType: BrandingEntityType | "DEFAULT"
): BrandingLevel {
  if (entityType === "DEFAULT") return "DEFAULT";
  return entityType;
}
